"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Label = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Label_module_scss_1 = __importDefault(require("./Label.module.scss"));
var Label = function (_a) {
    var children = _a.children, _b = _a.labelText, labelText = _b === void 0 ? "" : _b, _c = _a.labelType, labelType = _c === void 0 ? "text" : _c, _d = _a.labelPosition, labelPosition = _d === void 0 ? "end" : _d, _e = _a.reversed, reversed = _e === void 0 ? false : _e, _f = _a.variant, variant = _f === void 0 ? "default" : _f, disabled = _a.disabled, automationId = _a.automationId, classNameOverride = _a.classNameOverride, restProps = __rest(_a, ["children", "labelText", "labelType", "labelPosition", "reversed", "variant", "disabled", "automationId", "classNameOverride"]);
    return (react_1["default"].createElement("label", __assign({ "data-automation-id": automationId, className: (0, classnames_1["default"])(Label_module_scss_1["default"].label, classNameOverride, Label_module_scss_1["default"][labelType], reversed && Label_module_scss_1["default"].reversed, variant === "prominent" && Label_module_scss_1["default"].prominent, disabled && Label_module_scss_1["default"].disabled) }, restProps),
        children,
        react_1["default"].createElement("span", { className: (0, classnames_1["default"])(labelPosition === "start" && Label_module_scss_1["default"].prependedLabel, labelPosition === "end" && Label_module_scss_1["default"].appendedLabel) }, labelText)));
};
exports.Label = Label;
exports.Label.displayName = "Label";
//# sourceMappingURL=Label.js.map